var _defs, _rect, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew258({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.66,
    y: 5.24,
    width: 7.34,
    height: 5.52
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.6 8.67 8 8.67 8 5.24 15.34 5.24 13.6 8.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.91,13.31a2,2,0,0,1-.84.15,1.5,1.5,0,0,1-1.58-1.62,1.59,1.59,0,0,1,1.67-1.68,1.64,1.64,0,0,1,.76.15l-.1.33a1.62,1.62,0,0,0-.65-.13,1.19,1.19,0,0,0-1.25,1.32,1.17,1.17,0,0,0,1.23,1.29,1.71,1.71,0,0,0,.68-.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.57,13.42v-.84H13.14V12.3l1.38-2H15v1.92h.43v.33H15v.84Zm0-1.17v-1c0-.16,0-.32,0-.49h0c-.09.18-.17.32-.25.46l-.76,1.05h1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew258);
export default __webpack_public_path__ + "static/media/Symbolpack_New_258.acbf35357d8ce4e7e8d9b9bde6ab8551.svg";
export { ForwardRef as ReactComponent };